module.exports = __webpack_public_path__ + "02_long_brown.946bd8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_long_brown.png
// module id = Viu2
// module chunks = 0